<template>
  <div class="kt-notes__item">
    <div class="kt-notes__media">
      <h3 class="kt-notes__user kt-font-light kt-font-boldest kt-bg-danger">
        <slot name="icon" />
      </h3>
    </div>
    <div class="kt-notes__content">
      <span class="kt-notes__body">
        <slot name="content" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabItineraryItemHeader'
}
</script>

<style lang="scss" scoped>
.kt-notes__item {
  padding-bottom: 20px !important;
  border-left: 1px solid #c1323e !important;
  padding-left: 0px !important;
  transition: all 0.4s ease-out;
  opacity: 1;
}
.kt-notes__media {
  left: -16.5px !important;
}
.kt-notes__user {
  width: 30px !important;
  height: 30px !important;
  border: 40px !important;
  font-size: 1.8rem !important;
}
.kt-notes__content {
  padding: 0.1rem !important;
  background-color: #ffffff !important;
  border-radius: 0 !important;
}
.kt-notes__item:last-child .kt-notes__content {
  border-bottom: none !important;
}
.kt-notes__content:after {
  border-right: solid 10px transparent !important;
}
.kt-notes__body {
  padding: .3rem 2rem !important;
  color: #032647 !important;
}
</style>
